/**
 * cart-image-magnifier.js
 * Cart Image Magnifier (Lightbox) - JavaScript extracted from cart-image-magnifier.liquid
 */

(function() {
  'use strict';

  function initCartMagnifier() {
    const magnifier = document.getElementById('cart-image-magnifier');
    if (!magnifier) return;

    const dialog = magnifier.querySelector('[ref="dialog"]');
    const backdrop = magnifier.querySelector('[ref="backdrop"]');
    const closeButton = magnifier.querySelector('[ref="closeButton"]');
    const image = magnifier.querySelector('[ref="image"]');
    const productLink = magnifier.querySelector('[ref="productLink"]');

    if (!dialog || !image) return;

    function openMagnifier(imageSrc, altText, productUrl) {
      image.src = imageSrc;
      image.alt = altText || 'Product afbeelding';
      if (productLink) productLink.href = productUrl || '#';

      if (backdrop) backdrop.classList.add('active');
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }

    function closeMagnifier() {
      dialog.classList.add('dialog-closing');
      if (backdrop) backdrop.classList.remove('active');

      setTimeout(function() {
        dialog.close();
        dialog.classList.remove('dialog-closing');
        document.body.style.overflow = '';
        image.src = '';
      }, 150);
    }

    if (backdrop) backdrop.addEventListener('click', closeMagnifier);
    if (closeButton) closeButton.addEventListener('click', closeMagnifier);

    dialog.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeMagnifier();
      }
    });

    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) {
        closeMagnifier();
      }
    });

    // Global click handler for triggers
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('.cart-magnifier__trigger');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      const img = trigger.querySelector('img');
      if (!img) return;

      const isTeeImage = trigger.classList.contains('cart-magnifier__trigger--tee');

      if (isTeeImage) {
        const teeContainer = img.closest('.tee-cart-thumbnail');
        const containerLoaded = teeContainer?.classList.contains('loaded');
        const imgHasClass = img.classList.contains('tee-image-loaded');
        const isActuallyLoaded = img.complete && img.naturalHeight > 0;

        if (!containerLoaded && !imgHasClass && !isActuallyLoaded) return;
      }

      const imageSrc = img.src;
      const altText = img.alt;
      const productUrl = trigger.dataset.productUrl;

      openMagnifier(imageSrc, altText, productUrl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartMagnifier);
  } else {
    initCartMagnifier();
  }
})();
